import { createContext } from 'react';
const SplitResizeContext = createContext();
export default SplitResizeContext;
